export default __webpack_public_path__ + "static/hvac-service-repair-95c0378f95a7efce5f69c1b335616eb6.jpg";